import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initSentry } from './lib/sentry'
import { initAnalytics } from './lib/analytics'
import './index.css'
import App from './App.tsx'

// Initialize error tracking and analytics before rendering
initSentry();
initAnalytics();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
